export function getFirebaseConfig() {
  return require("./firebase_app_config.json");
}
